<template>
	<div class="admin-index">
		<h1 class="admin-index__title">
			<Icon type="team" />
			Управление пользователями
		</h1>

		<div class="admin-index__actions">
			<!-- Создать нового пользователя -->
			<UserCreate @success="getUsers" />

			<!-- Связать двух пользователей -->
			<UserLink @set-filter-function="onSetFilterFunction" @set-row-selection="onSetRowSelection" @refresh="getUsers" />
		</div>

		<div>
			Фильтр по email
			<a-input v-model="filter" allow-clear></a-input>
		</div>

		<br />

		<UserTable
			:rowSelection="rowSelection"
			:users="normalizedUsers"
			:isLoading="isUsersLoading"
			:pagination="tablePagination"
			@refresh="getUsers"
			@link-product="getUsers"
			@unlink-product="getUsers"
			@delete-sessions="getUsers"
			@delete-user="getUsers"
			@change="onTableChange"
		/>
	</div>
</template>

<script>
import { Icon } from "ant-design-vue"

export default {
	name: "AdminIndex",

	components: {
		Icon,
		UserCreate: () => import("@/components/UserCreate"),
		UserLink: () => import("@/components/UserLink"),
		UserTable: () => import("@/components/UserTable")
	},

	data() {
		return {
			users: [],
			filter: null,
			usersFilterFunction: null,
			rowSelection: null,
			isUsersLoading: false,
			page: 1,
			perPage: 20,
			total: 0,
			filterTimer: null
		}
	},

	computed: {
		tablePagination() {
			return {
				current: this.page,
				pageSize: this.perPage,
				total: this.total,
				showSizeChanger: true,
				showTotal: total => `Всего: ${total}`
			}
		},

		normalizedUsers() {
			let users = this.users

			if (this.usersFilterFunction) {
				users = users.filter(this.usersFilterFunction)
			}

			return users
		}
	},

	methods: {
		/**
		 * Получить пользователей
		 */
		async getUsers(page = this.page) {
			this.page = page
			this.isUsersLoading = true

			try {
				const { items, pagination } = await this.$context.adminUserService.getUsers({
					page: this.page,
					perPage: this.perPage,
					query: this.filter
				})

				this.users = items
				this.total = pagination.total || 0
				this.page = pagination.page || this.page
				this.perPage = pagination.per_page || this.perPage
			} catch (message) {
				this.$alert.error(message)
			}

			this.isUsersLoading = false
		},

		onSetFilterFunction(func) {
			this.usersFilterFunction = func
		},

		onSetRowSelection(newRowSelection) {
			this.rowSelection = newRowSelection
		},

		onTableChange({ pagination }) {
			if (!pagination) {
				return
			}

			const nextPage = pagination.current || 1
			const nextPerPage = pagination.pageSize || this.perPage

			if (nextPerPage !== this.perPage) {
				this.perPage = nextPerPage
				this.getUsers(1)
				return
			}

			if (nextPage !== this.page) {
				this.getUsers(nextPage)
			}
		}
	},

	watch: {
		filter() {
			clearTimeout(this.filterTimer)
			this.filterTimer = setTimeout(() => this.getUsers(1), 300)
		}
	},

	beforeDestroy() {
		clearTimeout(this.filterTimer)
	},

	mounted() {
		this.getUsers()
	}
}
</script>

<style lang="scss" scoped>
.admin-index {
	&__title {
		font-size: 22px;
	}

	&__actions {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-end;
	}
}
</style>
